// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mail-controls-container{display:flex}@media screen and (min-width: 576px){.mail-controls-container{flex-direction:column}}.mail-control{font-size:70%;margin:.15em;width:100%}@media screen and (min-width: 576px){.mail-control{font-size:90%;text-align:start}}", ""]);
// Exports
module.exports = exports;
